import {
	applyRoleBasedAccessFilter,
	focusRoleBasedAccess,
	openRoleBasedAccessSection,
} from './adapter';
import {
	openRoleBasedAccessCreateModal,
	openRoleBasedAccessDeleteModal,
	openRoleBasedAccessEditModal,
} from './modal';
import {resolveRoleBasedAccess} from './resolver';

/**
 * Role Profiles for role-based dynamic authorization.
 *
 * "Role" means four things in Canvas: the WAN interface role on an Access
 * Point and on a Site, the permission role a person is given, and this -
 * the profile a client is authorized against. The resource is named
 * role_based_access so the bare word keeps answering as the settings that
 * already had it, the way user_role does.
 *
 * Behind a feature licence (DYNAMIC_VLAN), so the section may not be
 * rendered at all for a tenant that does not have it.
 *
 * Declares no fields: the Edit form carries its own Rules table, which is
 * a row within a row and is left to the person.
 */
const roleBasedAccessPlugin = {
	id: 'role_based_access',
	version: 1,
	commandVersion: 1,
	resource: 'role_based_access',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.role_based_access': openRoleBasedAccessSection,
	},
	resolvers: {
		role_based_access: resolveRoleBasedAccess,
	},
	filters: {
		role_based_access: (command) =>
			applyRoleBasedAccessFilter(command.params?.query),
	},
	focusHandlers: {
		role_based_access: (command) =>
			focusRoleBasedAccess(command.params?.entity_id),
	},
	modals: {
		'role_based_access.create': openRoleBasedAccessCreateModal,
		'role_based_access.edit': openRoleBasedAccessEditModal,
		'role_based_access.delete': openRoleBasedAccessDeleteModal,
	},
};

export default roleBasedAccessPlugin;
